/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var CodeFileIcon = createIcon("CodeFileIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#4A9912';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.138 29.12v-2.568l-7.32-2.796L18.15 20.9v-2.592L7.506 22.484v2.508l10.632 4.128Zm3.864 3.54 6.048-18.012h-2.124L19.89 32.66h2.112Zm7.848-3.54 10.644-4.128v-2.508l-10.656-4.176V20.9l7.356 2.856-7.344 2.796v2.568Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.CodeFileIcon",
  "replaceColor": true
});